/**
 * @fileoverview Application route path constants.
 * @description Centralizes every route path string used by the router, route guards, and
 * post-login redirects, so a path only ever needs to change in one place.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  // The path the identity backend's invitation email links to ({APP_URL}/invitation/accept?token=).
  ACCEPT_INVITATION: '/invitation/accept',
  TWO_FACTOR: '/two-factor',
  DASHBOARD: '/sales/dashboard',
  SALES_CLIENTS: '/sales/clients',
  SALES_MY_PAGE: '/sales/my-page',
  SALES_PIPELINE: '/sales/pipeline',
  SALES_TEAM: '/sales/team',
  SALES_PERFORMANCE: '/sales/performance',
  SALES_USERS: '/sales/users',
  SALES_CAPABILITIES: '/sales/capabilities',
  AUDIT_LOG: '/audit-log',
  BANKING_OVERVIEW: '/banking/overview',
  BANKING_BANK_DETAILS: '/banking/bank-details',
  BANKING_MEMBERSHIP: '/banking/membership-share-capital',
  BANKING_MEMBERSHIP_MEMBER_COUNT: '/banking/membership-share-capital/member-count',
  BANKING_MEMBERSHIP_SHARE_CAPITAL_SEGMENTATION:
    '/banking/membership-share-capital/share-capital-segmentation',
  BANKING_CUSTOMER_BASE: '/banking/customer-base',
  BANKING_DEPOSITS: '/banking/deposits-portfolio',
  BANKING_DEPOSITS_COST_OF_DEPOSIT: '/banking/deposits-portfolio/cost-of-deposit',
  BANKING_DEPOSITS_AVERAGES: '/banking/deposits-portfolio/deposit-averages',
  BANKING_LOANS: '/banking/loans-advances',
  BANKING_LOANS_PRODUCT_WISE: '/banking/loans-advances/product-wise',
  BANKING_LOANS_INTEREST_RATE_WISE: '/banking/loans-advances/interest-rate-wise',
  BANKING_INVESTMENTS: '/banking/investments',
  BANKING_ASSET_QUALITY: '/banking/asset-quality',
  BANKING_PROFITABILITY: '/banking/profitability',
  BANKING_CAPITAL_ADEQUACY: '/banking/capital-adequacy',
  BANKING_BRANCH_ANALYTICS: '/banking/branch-analytics',
  BANKING_BRANCH_ANALYTICS_INCOME_SHARE: '/banking/branch-analytics/income-share',
  BANKING_BRANCH_ANALYTICS_SPREAD_CI_INCOME_MIX: '/banking/branch-analytics/spread-ci-income-mix',
  BANKING_PRODUCTIVITY: '/banking/productivity-efficiency',
  BANKING_BUSINESS_PERFORMANCE: '/banking/business-performance',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  CHANGE_PASSWORD: '/change-password',
  NOT_FOUND: '/404',
  FORBIDDEN: '/403',
  SERVER_ERROR: '/500',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  CONTACT_SUPPORT: '/contact-support',
} as const
